import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "nav-container"
}
const _hoisted_2 = { class: "desktop-menu" }
const _hoisted_3 = {
  key: 0,
  class: "submenu"
}
const _hoisted_4 = { class: "mobile-menu" }
const _hoisted_5 = {
  key: 0,
  class: "mobile-menu-items"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.store.token)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.label,
              to: item.to || '',
              class: _normalizeClass(["nav-item", { 'has-submenu': item.items }]),
              onClick: ($event: any) => (item.command ? item.command() : null)
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(item.icon)
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(item.label), 1),
                (item.items)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (subItem) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          key: subItem.label,
                          to: subItem.to || '',
                          class: "submenu-item",
                          onClick: ($event: any) => (subItem.command ? subItem.command() : null)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: _normalizeClass(subItem.icon)
                            }, null, 2),
                            _createElementVNode("span", null, _toDisplayString(subItem.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "onClick"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to", "class", "onClick"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            class: "menu-toggle",
            icon: "pi pi-bars",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMobileMenuOpen = !_ctx.isMobileMenuOpen))
          }),
          (_ctx.isMobileMenuOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allChildMenus, (item) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: item.label,
                    to: item.to || '',
                    class: "mobile-nav-item",
                    onClick: ($event: any) => (_ctx.onNavButtonClick(item))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(item.icon)
                      }, null, 2),
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "onClick"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}